import { CardTypeEnum } from '@varo/graphql-schema-types';
import React from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import AmplitudeMask from 'shared/components/AmplitudeMask/AmplitudeMask';
import IconButton from 'shared/components/vxl/icon/IconButton/IconButton';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

export interface CardBackProps {
  cardType: CardTypeEnum;
  firstNameText: string;
  lastNameText: string;
  cardNumberText: string;
  expirationLabel: string;
  expirationDateText: string;
  cvvLabel: string;
  cvvNumberText: string;
  handleCopyToClipboard: () => void;
  disabled?: boolean;
  isFlipped: boolean;
}

export const CardBack = (props: CardBackProps) => {
  return (
    <ImageBackground
      source={
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        require('assets/images/vxl/component/digitalCard/card-back.png') as ImageSourcePropType
      }
      style={styles.backImageContainer}
      accessible
      accessibilityLabel="Card back image"
      testID="card-back-image"
    >
      <View style={styles.textBackContainer}>
        {props.cardType === CardTypeEnum.ChargeCard ? (
          <>
            <AmplitudeMask>
              <TitleMdText
                style={styles.textNameBack}
                numberOfLines={0}
                allowFontScaling={false}
              >
                {props.firstNameText}
              </TitleMdText>
            </AmplitudeMask>
            <AmplitudeMask>
              <TitleMdText
                style={styles.textNameBack}
                numberOfLines={0}
                allowFontScaling={false}
              >
                {props.lastNameText}
              </TitleMdText>
            </AmplitudeMask>
          </>
        ) : null}
        <View style={styles.textNumberBackContainer}>
          <AmplitudeMask>
            <BodyBaseText
              style={styles.textNumberBack}
              numberOfLines={0}
              testID="Card number"
              allowFontScaling={false}
            >
              {props.cardNumberText}
            </BodyBaseText>
          </AmplitudeMask>

          <TouchableOpacity
            disabled={props.disabled ?? false}
            key={props.cardNumberText}
            hitSlop={20}
            onPress={() => {
              if (props.isFlipped) {
                props.handleCopyToClipboard();
              }
            }}
            style={styles.touchableArea}
            testID="Copy card number"
          >
            <IconButton
              iconColor={theme.color.text.inverse}
              iconKey="COPY"
              iconSize="MD"
              hoverColor={theme.color.text.tertiary}
              focusedColor={theme.color.text.inverse}
              iconButtonAccessibilityLabel="Copy card number"
              iconOnPress={() => {
                if (props.isFlipped) {
                  props.handleCopyToClipboard();
                }
              }}
              analyticsId="copyNumber"
            />
          </TouchableOpacity>
        </View>
        <AmplitudeMask>
          <BodyBaseText
            style={styles.textNumberBack}
            numberOfLines={0}
            testID="Exp cvv"
            allowFontScaling={false}
          >
            {props.expirationLabel +
              ' ' +
              props.expirationDateText +
              '         ' +
              props.cvvLabel +
              '\u00A0' +
              props.cvvNumberText}
          </BodyBaseText>
        </AmplitudeMask>
      </View>
    </ImageBackground>
  );
};

export const styles = StyleSheet.create({
  backImageContainer: {
    borderBottomLeftRadius: 18,
    borderBottomRightRadius: 18,
    height: 343,
    justifyContent: 'space-between',
    maxWidth: 405,
    overflow: 'hidden',
    width: '100%',
  },
  textBackContainer: {
    bottom: theme.spacing.xl,
    left: '28%',
    position: 'absolute',
  },
  textNameBack: {
    ...theme.typography.title.md,
    color: theme.color.text.inverse,
  },
  textNumberBack: {
    ...theme.typography.body.base,
    color: theme.color.text.inverse,
    marginRight: theme.spacing.s,
    marginTop: theme.spacing.m,
  },
  textNumberBackContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
  },
  touchableArea: {
    borderRadius: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
    zIndex: 1,
  },
});
